import { useState, useEffect } from 'react'
import type { RelatedProductItem as IRelatedProducts } from '@/types/IOrder'

export const useRelatedProducts = ({
  data,
  parentName,
  form,
}: {
  data: IRelatedProducts[]
  parentName: number
  form: any
}) => {
  const [supportLevel, setSupportLevel] = useState('')
  const formValues = form.getFieldsValue()

  const relatedProducts =
    data?.items?.[parentName]?.order_request?.related_products ??
    data?.items?.[parentName]?.product?.related_products ?? []

  useEffect(() => {
    if (!supportLevel && relatedProducts.length > 0) {
      const firstLevel =
        relatedProducts.find(p => p.pivot?.support_level)?.pivot?.support_level
      if (firstLevel) {
        setSupportLevel(firstLevel)
      }
    }
  }, [relatedProducts, supportLevel])

  const filteredProducts = relatedProducts.filter(product =>
    (product.product?.pivot?.support_level ?? product.pivot?.support_level) ===
    (formValues?.items?.[parentName]?.support_level ?? supportLevel)
  )

  const handleSupportLevelChange = (value: string) => {
    setSupportLevel(value)
  }

  return {
    relatedProducts,
    supportLevel,
    filteredProducts,
    handleSupportLevelChange,
  }
}
